import { toast } from 'react-toastify'

import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import useSearchParams from '@/hooks/useSearchParams'
import { useLoadCustomerFields } from '@/queries/customerFields/useLoadCustomerField'
import { useUpdateCustomerFields } from '@/queries/customerFields/useUpdateCustomerField'
import { CustomerField } from '@/types/customerField'
import { sanitizeText } from '@/utils/sanitizeText'

import { CustomFieldsForm } from './CustomFieldsForm'
import { CustomFieldsFormModel } from './useCustomFieldsForm'

export const EditCustomFieldsForm = () => {
  const searchParams = useSearchParams()

  const { data: customerFields, isLoading: isLoadingLoadCustomerFields } =
    useLoadCustomerFields()
  const updateParams = useUpdateURLSearchParams()
  const { updateCustomerField, isLoading: isLoadingUpdateCustomerField } =
    useUpdateCustomerFields()

  const customerFieldId = String(searchParams.get('editId') || '')

  const currentCustomerField = customerFields?.find(
    (item) => item.id === customerFieldId
  )

  const onFormSubmit = (data: CustomFieldsFormModel) => {
    const formattedPayload: CustomerField = {
      id: currentCustomerField?.id || '',
      label: data.label,
      name: sanitizeText(data.label),
      type: data.type as CustomerField['type'],
      show_in_client_mapping: data.show_in_client_mapping ?? false,
    }

    updateCustomerField(formattedPayload)
      .then(() => {
        toast.success('Custom field updated')
        updateParams(['editId', undefined])
      })
      .catch(() => {
        toast.error('Error updating custom field')
      })
  }

  const isLoading = isLoadingLoadCustomerFields || isLoadingUpdateCustomerField

  return (
    <CustomFieldsForm
      {...{
        onFormSubmit,
        isPending: isLoading,
        initialValues: currentCustomerField,
      }}
    />
  )
}
